var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 0.708984C8.91656 0.708984 3.98438 5.70633 3.98438 11.8699C3.98438 20.1696 12.7941 29.2896 15.0005 29.2896C17.2069 29.2896 26.0156 20.1696 26.0156 11.8699C26.0156 5.70633 21.0839 0.708984 15.0005 0.708984Z",
    fill: "#3EA2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7267 0.736328C15.8936 2.08445 16.0037 3.59383 16.0764 5.23117C19.2545 5.75477 21.6836 8.54008 21.6836 11.908C21.6836 15.2348 19.3136 17.9957 16.1926 18.5662C16.0937 22.4882 15.6456 26.1393 14.9326 29.2818C14.9546 29.2837 14.9795 29.2902 15.0001 29.2902C17.2065 29.2902 26.0153 20.1702 26.0153 11.8705C26.0153 5.95398 21.4721 1.11602 15.7267 0.736328Z",
    fill: "#1D87A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4474 13.6699C20.681 16.5541 18.0883 18.6799 15.0002 18.6799C12.0382 18.6799 9.52941 16.7252 8.65332 14.0215C8.94676 18.0616 11.651 20.5 15.0002 20.5C18.4455 20.4995 21.2913 17.8751 21.4474 13.6699Z",
    fill: "#1D87A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 1.67648C20.9039 1.67648 25.7203 6.38133 26.002 12.2909C26.0067 12.1502 26.0156 12.0101 26.0156 11.8704C26.0156 5.7068 21.0839 0.708984 15.0005 0.708984C8.91703 0.708984 3.98438 5.70633 3.98438 11.8699C3.98438 12.0101 3.99375 12.1502 3.99797 12.2904C4.27969 6.38133 9.09797 1.67648 15.0005 1.67648Z",
    fill: "#4FCCED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C18.866 19 22 15.866 22 12C22 8.13401 18.866 5 15 5C11.134 5 8 8.13401 8 12C8 15.866 11.134 19 15 19Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1117 7.4914C18.9303 6.51667 17.4162 5.93057 15.7659 5.93057C11.9904 5.93057 8.92939 8.99545 8.92939 12.7758C8.92939 14.4281 9.51475 15.9441 10.4883 17.127C8.96846 15.8715 8 13.9713 8 11.8452C8 8.06488 11.061 5 14.8365 5C16.96 5 18.8578 5.96968 20.1117 7.4914Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/LocationMarker.17a15d9aa5b94fcdf73c8681eca612a7.svg";
export { ForwardRef as ReactComponent };